import { uiConstants } from "./ui.constants";
import fp from "lodash/fp";

const initialState = {
	notification: { show: false, variant: "info" },
	isSpinnerOverlayVisible: false,
	modals: [],
	isOnline: true,
};

export const getUIState = state => state.ui;

// prettier-ignore
const selector = property =>
	fp.flow(getUIState, fp.property(property));

export const getModals = selector("modals");

export const getIsOnline = selector("isOnline");

export function ui(state = initialState, action) {
	switch (action.type) {
		case uiConstants.OPEN_NOTIFICATION:
			return {
				...state,
				notification: {
					...state.notification,
					show: true,
					title: action.title,
					variant: action.variant,
				},
			};
		case uiConstants.CLOSE_NOTIFICATION:
			return {
				...state,
				notification: { show: false, variant: "info" },
			};
		case uiConstants.SHOW_SPINNER_OVERLAY:
			return {
				...state,
				isSpinnerOverlayVisible: true,
			};
		case uiConstants.HIDE_SPINNER_OVERLAY:
			return {
				...state,
				isSpinnerOverlayVisible: false,
			};
		case uiConstants.PUSH_MODAL:
			return {
				...state,
				modals: [...state.modals, action.modal],
			};
		case uiConstants.POP_MODAL:
			return {
				...state,
				modals: fp.dropLast(1, state.modals),
			};
		case uiConstants.SET_IS_ONLINE:
			return fp.set("isOnline", action.isOnline, state);
		default:
			return state;
	}
}
